<form [formGroup]="customFieldFormGroup" [class]="'field-type-' + customField.definition.type.type">
  <div class="label-field-and-tooltip-container">
    <div class="label-and-field-container">
      <ion-label class="label-container">
        <span>{{
          customField.definition.standard_field_id
            ? (customField.definition.label | translate)
            : customField.definition.label
        }}</span>
        <span *ngIf="!customField.definition.type.can_set_null">*</span>
      </ion-label>
      <ng-container [ngSwitch]="customField.definition.type.type">
        <ng-container *ngSwitchCase="CustomFieldTypeName.String">
          <ng-container *ngTemplateOutlet="stringTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Integer">
          <ng-container *ngTemplateOutlet="numberTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Float">
          <ng-container *ngTemplateOutlet="numberTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.URL">
          <ng-container *ngTemplateOutlet="stringTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Phone">
          <ng-container *ngTemplateOutlet="phoneTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Email">
          <ng-container *ngTemplateOutlet="stringTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Boolean">
          <ng-container *ngTemplateOutlet="booleanTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Enumerate">
          <ng-container *ngTemplateOutlet="selectSingleTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Multipicklist"
          ><ng-container *ngTemplateOutlet="selectMultipleTypeTemplate"></ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Date">
          <ng-container *ngTemplateOutlet="dateTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchCase="CustomFieldTypeName.Datetime">
          <ng-container *ngTemplateOutlet="datetimeTypeTemplate"> </ng-container
        ></ng-container>
        <ng-container *ngSwitchDefault>n/a</ng-container>
      </ng-container>
    </div>
    <ion-icon
      [matTooltip]="
        customField.definition.standard_field_id
          ? (customField.definition.description | translate)
          : customField.definition.description
      "
      name="help-circle-outline"></ion-icon>
  </div>
  <div class="validation-error-container">
    <div *ngIf="customFieldFormGroup.errors?.validationError as validationError">
      {{ validationError.translation_key | translate: validationError.placeholders }}
    </div>
  </div>

  <ng-template #stringTypeTemplate>
    <ion-input formControlName="fieldValue" type="text" clearInput="true"></ion-input>
  </ng-template>

  <ng-template #numberTypeTemplate>
    <ion-input formControlName="fieldValue" type="number" clearInput="true"></ion-input>
  </ng-template>

  <ng-template #booleanTypeTemplate>
    <ion-toggle formControlName="fieldValue"></ion-toggle>
  </ng-template>

  <ng-template #phoneTypeTemplate>
    <app-phone-number-input formControlName="fieldValue"></app-phone-number-input>
  </ng-template>

  <ng-template #selectSingleTypeTemplate>
    <app-select-ionic [options]="optionsForSelect" [required]="true" formControlName="fieldValue"></app-select-ionic>
  </ng-template>

  <ng-template #selectMultipleTypeTemplate>
    <app-select-ionic [options]="optionsForSelect" [multiple]="true" formControlName="fieldValue"></app-select-ionic>
  </ng-template>

  <ng-template #dateTypeTemplate>
    <app-datetime-ionic [withTime]="false" formControlName="fieldValue"></app-datetime-ionic>
  </ng-template>

  <ng-template #datetimeTypeTemplate>
    <app-datetime-ionic [withTime]="true" formControlName="fieldValue"></app-datetime-ionic>
  </ng-template>
</form>
